import useSWR from 'hooks/useSWR';

export default id =>
  useSWR({
    url: `/v1/maple_payments/${id}`,
    swrOptions: { if: Boolean(id) }
  });
